export const LISTCONTACT_REQUEST="LISTCONTACT_REQUEST"
export const LISTCONTACT_SUCCESS="LISTCONTACT_SUCCESS"
export const LISTCONTACT_FAIL="LISTCONTACT_FAIL"